import React from 'react';
import LoadingIndicator from '../components/shared/LoadingIndicator/LoadingIndicator';
import BacklinksOverview from './overview/BacklinksOverview';
import { backlinksOverviewMainPageDisplayOrder } from './settings';
import BacklinksTabs from './results/BacklinksTabs';
import { useFetchBacklinksOverviewQuery } from './service';
import { getBacklinksOverviewForInterval } from './utils';
import { TimeUtil } from '../utils/time';
import './Backlinks.less';


type Props = {
    domain: string;
};


export default function Backlinks({ domain }: Props) {
    const endDateStr = TimeUtil.utcNow().format('YYYY-MM-DD');
    const startDateStr = TimeUtil.utcNow().subtract(4, "weeks").format('YYYY-MM-DD');

    const { data: backlinksOverview, isLoading: isLoadingOverview } = useFetchBacklinksOverviewQuery({ domain: domain });
    const isBacklinksOverviewExistent = !isLoadingOverview && backlinksOverview;

    return (
        <div className="backlinks">
            <div className="backlinks-overview">
                {isLoadingOverview && <LoadingIndicator />}

                {isBacklinksOverviewExistent && (
                    <BacklinksOverview
                        overview={getBacklinksOverviewForInterval(backlinksOverview, startDateStr, endDateStr)}
                        showChart={true}
                        displayOrder={backlinksOverviewMainPageDisplayOrder}
                    />
                )}
            </div>

            <BacklinksTabs domain={domain} />
        </div>
    );
}
